import { recommenderExercisesAtom } from 'dataLayer/recoil/apiData/atoms';
import { selector } from 'recoil';
import { filterAndParseExerciseRoutines } from 'dataLayer/recoil/pages/helpers/recommenderHelper';

export const exerciseRoutineEveningSelector = selector({
  key: 'pages/stayActive/selectors/exerciseRoutineEvening',
  get: ({ get }) => {
    const recommenderExercises = get(recommenderExercisesAtom);

    return filterAndParseExerciseRoutines(
      recommenderExercises,
      'my-evening-stretches'
    );
  },
});
